module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-plausible/gatsby-browser.js'),
      options: {"plugins":[],"domain":"oomnis.io"},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"localeJsonSourceName":"locale","languages":["en","fr","ja","es"],"defaultLanguage":"en","siteUrl":"https://www.oomnis.io/","i18nextOptions":{"fallbackLng":"en","ignoreJSONStructure":false,"interpolation":{"escapeValue":false},"keySeparator":".","nsSeparator":":","defaultNS":"translation","fallbackNS":"translation"},"pages":[],"redirect":true},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
